<template>
  <!-- roll房管理-roll房管理 -->
  <div class="roll-room">
    <el-row>
      <el-form :inline="true">
        <el-form-item label="ID">
          <el-input
            type="text"
            v-model="rollsParams.id"
            size="mini"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input
            type="text"
            v-model="rollsParams.user_id"
            size="mini"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户ID[查询加入ROLL房]">
          <el-input
            type="text"
            v-model="rollsParams.join_room"
            size="mini"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            type="text"
            v-model="rollsParams.name"
            size="mini"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select
            v-model="rollsParams.type"
            size="mini"
            style="width: 120px"
            @change="searchRoll"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="用户ROLL" value="2"></el-option>
            <el-option label="系统ROLL" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源">
          <el-select
            v-model="rollsParams.source_type"
            size="mini"
            style="width: 120px"
            placeholder="请选择来源"
            @change="searchRoll"
          >
            <el-option label="" value="">全部</el-option>
            <el-option label="官方房" :value="1"></el-option>
            <el-option label="主播房" :value="2"></el-option>
            <el-option label="每日房" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="rollsParams.state"
            size="mini"
            style="width: 120px"
            @change="searchRoll"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="未开始" value="1"></el-option>
            <el-option label="正在抽奖" value="2"></el-option>
            <el-option label="抽奖结束" value="3"></el-option>
            <el-option label="删除" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="rollsParams.start_time"
            align="right"
            type="date"
            placeholder="选择日期"
            size="mini"
            :picker-options="pickerOptions"
            style="width: 80px"
          >
          </el-date-picker>
          ->
          <el-date-picker
            v-model="rollsParams.end_time"
            align="right"
            type="date"
            placeholder="选择日期"
            size="mini"
            style="width: 80px"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            circle
            @click="searchRoll"
          ></el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd" size="mini"
            >添加ROLL房</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-switch
          v-model="switchStatus"
          :active-value="1"
          :inactive-value="0"
          active-text="打开roll详情"
          inactive-text="关闭roll详情"
          @change="setSwitch"
        >
        </el-switch>
        </el-form-item>
      </el-form>
      <!--			<el-button type="primary" @click="handleAdd">添加ROLL房</el-button>-->
    </el-row>
    <el-table :data="dataList" v-loading="loading">
      <el-table-column label="ID" width="60px">
        <template slot-scope="{ row }">
          <!-- <span @click="$router.push(`/roll/${row.id}?cid=${row.category_id}`)">{{ row.id }}</span> -->
          <span @click="pathToRoll(row)">{{ row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="房间名称">
        <template slot-scope="{ row }">
          <!-- <span @click="$router.push(`/roll/${row.id}?cid=${row.category_id}`)">{{ row.name }}</span> -->
          <span @click="pathToRoll(row)">{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发起人">
        <template slot-scope="{ row }">
          <div class="user-avatar">
            <img
              width="100"
              :src="row.user_avatar || '/images/default-avatar.jpg'"
              alt
            />
            <span>{{ row.user_name || "" }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="充值开始时间"
        width="100px"
      ></el-table-column>
      <el-table-column
        prop="end_time"
        label="充值结束时间"
        width="100px"
      ></el-table-column>
      <el-table-column prop="amount" label="充值额度"></el-table-column>
      <el-table-column prop="superior_id" label="上级id"></el-table-column>
      <el-table-column prop="sum_price" label="roll房金额"></el-table-column>
      <el-table-column prop="prize_num" label="奖品数量"></el-table-column>
      <el-table-column prop="number" label="最大加入人数"></el-table-column>
      <el-table-column prop="join_number" label="已加入人数"></el-table-column>
      <el-table-column prop="box_amount" label="开箱额度"></el-table-column>
      <el-table-column
        prop="box_start_time"
        label="开箱开始时间"
      ></el-table-column>
      <el-table-column
        prop="box_end_time"
        label="开箱结束时间"
      ></el-table-column>
      <el-table-column
        prop="battle_amount"
        label="热血盲盒额度"
      ></el-table-column>
      <el-table-column
        prop="battle_start_time"
        label="热血盲盒开始时间"
      ></el-table-column>
      <el-table-column
        prop="battle_end_time"
        label="热血盲盒结束时间"
      ></el-table-column>
      <el-table-column
        prop="upgrade_amount"
        label="幸运升级花费"
      ></el-table-column>
      <el-table-column
        prop="upgrade_start_time"
        label="幸运升级开始时间"
      ></el-table-column>
      <el-table-column
        prop="upgrade_end_time"
        label="幸运升级结束时间"
      ></el-table-column>
      <el-table-column prop="weight" label="权重"></el-table-column>
      <el-table-column prop="room_open_time" label="开始时间"></el-table-column>
      <el-table-column prop="finish_time" label="开奖时间"></el-table-column>
      <el-table-column prop="join_time" label="用户注册时间"></el-table-column>
      <el-table-column label="所属分类">
        <template slot-scope="{ row }">
          <span>{{ getCategoryName(row.category_id) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="房间状态">
        <template slot-scope="{ row }">
          <el-tag v-if="row.state === 1">未开始</el-tag>
          <el-tag v-if="row.state === 2" type="success">正在抽奖</el-tag>
          <el-tag v-if="row.state === 3" type="info">抽奖结束</el-tag>
          <el-tag v-if="row.state === 4" type="danger">删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240px" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            style="margin-bottom: 5px"
            type="primary"
            @click="handleEdit(row)"
            plain
            >编辑
          </el-button>
          <el-button type="primary" @click="pathToRoll(row)">详情 </el-button>
          <br />
          <el-button
            type="success"
            @click="runLottery(row.id, row.type)"
            v-if="row.state === 2"
            >开奖
          </el-button>
          <el-button
            type="primary"
            v-if="row.type === 2 && row.state === 3"
            @click="showHistory(row.id)"
            >开奖历史
          </el-button>
          <el-button type="warning" @click="toCopy(row.id)">复制 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="dataMeta1 ? dataMeta1.total : 0"
      :current-page="dataMeta1 ? dataMeta1.current_page : 1"
      :page-size="dataMeta1 ? dataMeta1.per_page : 15"
      @current-change="pageChange"
    ></el-pagination>

    <el-dialog
      :title="`${isEdit ? '编辑' : '添加'}ROLL房`"
      :visible.sync="visible"
      :close-on-click-modal="false"
      destroy-on-close
      width="500px"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formRoom"
        label-width="140px"
      >
        <el-form-item label="房间名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="房间描述" prop="name">
          <el-input v-model="formData.remark"></el-input>
        </el-form-item>
        <el-form-item label="房间图片" prop="image">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleImageUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img
              width="100"
              class="avatar"
              v-if="formData.image"
              :src="formData.image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="房间钥匙金额" prop="key_amount">
          <el-input
            v-model="formData.key_amount"
            placeholder="输入此roll房钥匙价值，无钥匙不输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="房间密码" prop="password">
          <el-input v-model="formData.password"></el-input>
        </el-form-item>
        <el-form-item label="充值开始时间" prop="start_time">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.start_time"
            type="datetime"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="充值结束时间" prop="end_time">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.end_time"
            type="datetime"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="充值额度" prop="amount">
          <el-input v-model="formData.amount"></el-input>
        </el-form-item>
        <el-form-item label="上级ID" prop="superior_id">
          <el-input v-model="formData.superior_id"></el-input>
        </el-form-item>
        <el-form-item label="开箱额度" prop="box_amount">
          <el-input v-model="formData.box_amount"></el-input>
        </el-form-item>
        <el-form-item
          label="开箱开始时间"
          prop="box_start_time"
          v-if="formData.box_amount"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.box_start_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="开箱结束时间"
          prop="box_end_time"
          v-if="formData.box_amount"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.box_end_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="热血盲盒额度" prop="battle_amount">
          <el-input v-model="formData.battle_amount"></el-input>
        </el-form-item>
        <el-form-item
          label="热血盲盒开始时间"
          prop="battle_start_time"
          v-if="formData.battle_amount"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.battle_start_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="热血盲盒结束时间"
          prop="battle_end_time"
          v-if="formData.battle_amount"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.battle_end_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="幸运升级花费" prop="upgrade_amount">
          <el-input v-model="formData.upgrade_amount"></el-input>
        </el-form-item>
        <el-form-item
          label="幸运升级开始时间"
          prop="upgrade_start_time"
          v-if="formData.upgrade_amount"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.upgrade_start_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="幸运升级结束时间"
          prop="upgrade_end_time"
          v-if="formData.upgrade_amount"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.upgrade_end_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发起人用户名" prop="user_name">
          <el-input v-model="formData.user_name"></el-input>
        </el-form-item>
        <el-form-item label="发起人头像" prop="user_avatar">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img
              class="avatar"
              width="100"
              v-if="formData.user_avatar"
              :src="formData.user_avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="最大加入人数" prop="number">
          <el-input v-model="formData.number" placeholder="默认1000"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input v-model="formData.weight" placeholder="默认1"></el-input>
        </el-form-item>
        <el-form-item label="人数显示" prop="show_num">
          <el-select v-model="formData.show_num">
            <el-option :value="1" label="999+"></el-option>
            <el-option :value="2" label="99+"></el-option>
            <el-option :value="3" label="正常"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动中心roll" prop="activity_roll">
          <el-select v-model="formData.activity_roll">
            <el-option :value="0" label="否"></el-option>
            <el-option :value="1" label="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="活动中心roll排序"
          prop="activity_roll_sort"
          v-if="formData.activity_roll === 1"
        >
          <el-input
            v-model="formData.activity_roll_sort"
            placeholder="活动中心roll排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="roll房人数展示" prop="roll_page_control">
          <el-select v-model="formData.roll_page_control">
            <el-option :value="1" label="全部人数"></el-option>
            <el-option :value="2" label="5页"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户最低等级" prop="min_level">
          <el-input
            v-model="formData.min_level"
            placeholder="请输入最低等级"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户最高等级" prop="max_level">
          <el-input
            v-model="formData.max_level"
            placeholder="请输入最高等级"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联限制" prop="card_max_nums">
          <el-input
            v-model="formData.card_max_nums"
            placeholder="请输入关联限制"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="room_open_time">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.room_open_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开奖时间" prop="finish_time">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.finish_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="每小时充值金额" prop="hour_recharge_amount">
          <el-input
            v-model="formData.hour_recharge_amount"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="充值金额次数" prop="hour_recharge_nums">
          <el-input
            v-model="formData.hour_recharge_nums"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>

        <el-form-item label="加入用户注册时间" prop="join_time">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.join_time"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="房间来源" prop="source_type">
          <el-select v-model="formData.source_type">
            <el-option :value="1" label="官方房"></el-option>
            <el-option :value="2" label="主播房"></el-option>
            <el-option :value="3" label="每日房"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="category_id" label="房间分类">
          <el-select
            v-model="formData.category_id"
            placeholder="请选择房间分类"
          >
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="state" v-if="isEdit">
          <el-select v-model="formData.state">
            <el-option :value="1" label="未开始"></el-option>
            <el-option :value="2" label="正在抽奖"></el-option>
            <el-option :value="3" label="抽奖结束"></el-option>
            <el-option :value="4" label="删除"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="ROLL历史" :visible.sync="rollHistoryShow">
      <el-table :data="historyData">
        <el-table-column prop="user.id" label="用户ID" />
        <el-table-column prop="user.name" label="用户名"></el-table-column>
        <el-table-column prop="user.avatar" label="用户头像">
          <template scope="{ row }">
            <el-image :src="row.user.avatar"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="prize.name" label="饰品名称" />
        <el-table-column prop="prize.image" label="饰品">
          <template scope="{ row }">
            <el-image :src="row.prize.image"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="prize.price" label="饰品价格" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import {
  postData,
  patchData,
  server,
  getApiData,
  patchApiData
} from '@/http'
import {
  getCookie
} from '@/utils/cookie'

export default {
  data() {
    return {
      switchStatus: 0,//打开或关闭 0是关闭 1是打开
      imgType: 'room', //上传图片的种类 roll房
      loading: false,
      visible: false,
      formData: {
        name: '',
        password: '',
        key_amount: '',
        start_time: '',
        end_time: '',
        amount: '',
        superior_id: undefined,
        box_amount: 0, //开箱额度
        box_start_time: '', //开箱开始时间
        box_end_time: '', //开箱结束时间
        battle_amount: 0, //热血盲盒额度
        battle_start_time: '', //热血盲盒开始时间
        battle_end_time: '', //热血盲盒结束时间
        upgrade_amount: '', //幸运升级花费
        upgrade_start_time: '', //幸运升级开始时间
        upgrade_end_time: '', //幸运升级结束时间
        number: '',
        weight: '',
        show_num: 1,
        activity_roll: 0, //是否是活动中心roll 0不是 1是；默认是0
        activity_roll_sort: 0, //活动中心roll排序 默认0
        roll_page_control: 1, //roll房间人数显示 1是全部 2是部分页数；默认是1
        min_level: '',
        max_level: '',
        card_max_nums: 0,//用户关联限制
        room_open_time: '',
        finish_time: '',
        hour_recharge_amount: 0,
        hour_recharge_nums: 0,
        join_time: '',
        state: 1,
        source_type: 3,//房间来源 1官方，2主播，3每日
        category_id: undefined,
        user_avatar: '',
        user_name: '',
        image: ''
      },
      isEdit: false,
      editInfo: undefined,
      rules: {
        name: [{
          required: true,
          message: '请输入房间名称'
        }],
        image: [{
          required: true,
          message: '请输入ROLL房图片'
        }],
        remark: [{
          required: true,
          message: '请输入ROLL房描述'
        }],
        box_start_time: [{
          required: true,
          message: '请输入开箱开始时间'
        }],
        box_end_time: [{
          required: true,
          message: '请输入开箱结束时间'
        }],
        battle_start_time: [{
          required: true,
          message: '请输入热血盲盒开始时间'
        }],
        battle_end_time: [{
          required: true,
          message: '请输入热血盲盒结束时间'
        }],
        upgrade_start_time: [{
          required: true,
          message: '请输入幸运升级开始时间'
        }],
        upgrade_end_time: [{
          required: true,
          message: '请输入幸运升级结束时间'
        }],
        room_open_time: [{
          required: true,
          message: '请输入开始时间'
        }],
        finish_time: [{
          required: true,
          message: '请输入开奖时间'
        }],
        source_type: [{
          required: true,
          message: '请选择房间来源'
        }],
        category_id: [{
          required: true,
          message: '请选择房间所属分类'
        }],
        user_name: [{
          required: true,
          message: '请填写发起人用户名'
        }],
        user_avatar: [{
          required: true,
          message: '请上传发起人头像'
        }]
      },
      buttonLoading: false,
      rollsParams: {
        id: null,
        name: null,
        type: null,
        start_time: null,
        end_time: null,
        source_type: null,
        category_id: null,
        page: 1,
        user_id: null,
        state: null,
        join_room: null
      },
      dataList: [],
      dataMeta1: {},
      rollData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      rollHistoryShow: false,
      historyData: [],
      rowId: ''
    }
  },
  computed: {
    ...mapState({
      // dataList: state => state.data.roomList.data,
      dataMeta: state => state.data.roomList.meta,
      categories: state => state.data.categories
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.isEdit && this.editInfo) {
          const {
            name,
            password,
            key_amount,
            start_time,
            end_time,
            amount,
            superior_id,
            box_amount,
            box_start_time,
            box_end_time,
            battle_amount,
            battle_start_time,
            battle_end_time,
            upgrade_amount,
            upgrade_start_time,
            upgrade_end_time,
            number,
            weight,
            show_num,
            activity_roll,
            activity_roll_sort,
            roll_page_control,
            min_level,
            max_level,
            card_max_nums,
            room_open_time,
            finish_time,
            hour_recharge_amount,
            hour_recharge_nums,
            join_time,
            state,
            source_type,
            category_id,
            user_avatar,
            user_name,
            remark,
            image
          } = this.editInfo
          this.formData = {
            name,
            password,
            key_amount,
            start_time,
            end_time,
            amount,
            superior_id,
            box_amount,
            box_start_time,
            box_end_time,
            battle_amount,
            battle_start_time,
            battle_end_time,
            upgrade_amount,
            upgrade_start_time,
            upgrade_end_time,
            number,
            weight,
            show_num,
            activity_roll,
            activity_roll_sort,
            roll_page_control,
            min_level,
            max_level,
            card_max_nums,
            room_open_time,
            finish_time,
            hour_recharge_amount,
            hour_recharge_nums,
            join_time,
            state,
            source_type,
            category_id,
            user_avatar,
            user_name,
            remark,
            image
          }
        }
      } else {
        this.formData = {
          name: '',
          password: '',
          key_amount: '',
          start_time: '',
          end_time: '',
          amount: '',
          superior_id: undefined,
          box_amount: undefined,
          box_start_time: '',
          box_end_time: '',
          battle_amount: undefined,
          battle_start_time: '',
          battle_end_time: '',
          upgrade_amount: undefined,
          upgrade_start_time: '',
          upgrade_end_time: '',
          number: '',
          weight: '',
          show_num: 1,
          activity_roll: 0,
          activity_roll_sort: 0,
          roll_page_control: 1,
          min_level: '',
          max_level: '',
          card_max_nums: 0,
          room_open_time: '',
          finish_time: '',
          hour_recharge_amount: 0,
          hour_recharge_nums: 0,
          join_time: '',
          state: 1,
          source_type: undefined,
          category_id: undefined,
          user_name: '',
          user_avatar: '',
          remark: '',
          image: ''
        }
      }
    }
  },
  created() {
    this.getData();
    this.getSwitch()
    !this.categories && this.getCategories()
  },
  methods: {
    ...mapActions(['getRoomList', 'getCategories']),
    getSwitch() {
      //获取关闭/打开开关状态
      getApiData('roll_detail_enable')
        .then(res => {
          if (res) {
            res.data ? this.switchStatus = 1 : this.switchStatus = 0
          }
        })
    },
    setSwitch() {
      //关闭/打开开关
      let params = { "black": this.switchStatus ? 1 : 0 }
      patchApiData('roll_detail_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getSwitch()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.switchStatus = this.switchStatus ? 0 : 1
        })
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    getData() {
      this.loading = true
      getApiData('rolls', this.rollsParams).then(res => {
        this.dataList = res.data
        this.rollData = res
        this.loading = false
        this.dataMeta1 = {
          current_page: res.current_page,
          per_page: res.per_page,
          total: res.total
        }
      })
      // this.getRoomList().finally(() => {
      // 	this.loading = false
      // })
    },
    pageChange(val) {
      this.rollsParams.page = val
      this.getData()
    },
    searchRoll() {
      this.rollsParams.page = null
      this.getData()
    },
    showHistory(id) {
      this.rowId = id
      this.rollHistoryShow = true
      getApiData('rolls/history/' + this.rowId).then(res => {
        this.historyData = res
      })
    },
    toCopy(id) {
      //复制roll房
      this.$confirm('确认复制此roll房？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        patchData(`roll_copy/${id}`).then(res => {
          this.$message.success('复制成功！')
          this.getData()//刷新数据
        })
      }).catch(() => { })
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.formData.user_avatar = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['formRoom'].validateField('user_avatar')
    },
    handleImageUploadSuccess(res) {
      if (res.path) {
        this.formData.image = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['formRoom'].validateField('image')
    },
    handleAdd() {
      this.isEdit = false
      this.editInfo = undefined
      this.visible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editInfo = row
      this.visible = true
    },
    runLottery(id, type) {
      this.$confirm('确定要开奖吗？', {
        type: 'warning'
      }).then(res => {
        patchData(`rooms/${id}/lottery`).then(res => {
          this.$message.success('开奖成功')
          this.getData()
        })
      })
    },
    submit() {
      const valid = this.$refs['formRoom'].validate()
      if (!valid) {
        return
      }

      if ((new Date().getTime() >= new Date(this.formData.finish_time).getTime()) || (new Date(this.formData.room_open_time).getTime() >= new Date(this.formData.finish_time).getTime())) {
        this.$message.error('开奖时间必须大于开始时间，开将时间必须大于当前时间')
        return
      }

      this.buttonLoading = true
      if (this.isEdit) {
        patchData(`rooms/${this.editInfo.id}`, {
          ...this.formData
        })
          .then(res => {
            this.$message.success('编辑成功')
            this.getData()
            this.visible = false
          })
          .finally(() => {
            this.buttonLoading = false
          })
      } else {
        postData('rooms', {
          ...this.formData
        })
          .then(res => {
            this.$message.success('添加成功')
            this.getData()
            this.visible = false
          })
          .finally(() => {
            this.buttonLoading = false
          })
      }
    },
    pathToRoll(row) {
      let routeData = this.$router.resolve({
        path: `/roll/${row.id}?cid=${row.category_id}`
      })
      window.open(routeData.href, '_blank')
    }
  },
}

</script>

<style>
</style>
